import cn from 'classnames';
import { forwardRef } from 'react';

export interface CheckboxProps {
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  disabled?: boolean;
  className?: string;
}

export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
  ({ checked, onChange, disabled, className }, ref) => {
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      if (onChange) {
        onChange(event.target.checked);
      }
    };

    return (
      <input
        ref={ref}
        type="checkbox"
        className={cn('form-check-input', className)}
        checked={checked}
        onChange={handleChange}
        disabled={disabled}
      />
    );
  }
);

Checkbox.displayName = 'Checkbox';
